import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { EditProvider } from "../../context/EditSpotlightState";
import BillingMobileHeader from "../../components/billing/BillingMobileHeader";
import BillingBody from "../../components/billing/BillingBody";

const CreateNew = () => {
  return (
    <EditProvider>
      <PageTemplate
        title="Billing"
        mobileHeader={<BillingMobileHeader />}
        sidebarTitle="Billing"
        sidebarSubtitle="Manage payment methods and view invoice history"
        centered
      >
        <BillingBody />
      </PageTemplate>
    </EditProvider>
  );
};

export default CreateNew;
